module.exports = function (page, popstate) {
    setTimeout(() => {
        document.body.classList.remove('is-changing');
        history.back();
        for (var i = 0; i <  this.specialPages.length; i++) {
            document.body.classList.remove(this.specialPages[i].class)
        }
    }, 100);
}


// WEBPACK FOOTER //
// ./core/xhr2/modules/goBack.js